/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-17 11:18:35
 * @FilePath: /insuranceagent-ui/src/components/verifition/utils/ase.js
 * @Description:
 */
import CryptoJS from 'crypto-js'

/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word, keyWord = 'XwKsGlMcdPMEhR1B') {
	var key = CryptoJS.enc.Utf8.parse(keyWord)
	var srcs = CryptoJS.enc.Utf8.parse(word)
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7})
	return encrypted.toString()
}

// /**
//  * AES解密
//  * @param word 需要解密的内容
//  * @param keyWord String 服务器随机返回的关键字
//  * @returns {string} 解密后的内容
//  */
// export function aesDecrypt(word, keyWord = 'XwKsGlMcdPMEhR1B') {
// 	var key = CryptoJS.enc.Utf8.parse(keyWord)
// 	var decrypt = CryptoJS.AES.decrypt(word, key, {
// 		mode: CryptoJS.mode.ECB,
// 		padding: CryptoJS.pad.Pkcs7,
// 	})
// 	return CryptoJS.enc.Utf8.stringify(decrypt)
// }
